import { Link } from 'react-router-dom'
import ContactForm from './components/ContactForm'

export default function Order() {
    return (
        <>
            <h2>1. Napiš mi</h2>
            <p>
                Napsat mi můžeš na můj instagram:{' '}
                <a
                    href="https://www.instagram.com/drippy_rugs/"
                    target="_blank"
                    rel="noreferrer"
                >
                    @drippy_rugs
                </a>
                , a nebo přes <a href="#contact-form">kontaktní formulář</a>.
            </p>

            <h2 className="mt-10">2. Pošli design</h2>
            <p>
                Pošli mi svůj vysněný design. Stačí když mi pošleš obrázek v
                jakémkoliv formátu a přijatelné kvalitě. Poté se spolu dohodneme
                na velikosti.
            </p>
            <p>
                Pokud máš v hlavě nápad a nemáš obrázek, design ti můžu na míru
                vymyslet.
            </p>
            <p>
                Při objednávání vem prosím v potaz jestli máš zájem o detailing
                koberečku. Na rozdíl koberečku s detailingem a bez něj se můžeš
                podívat <Link to="/compare">zde</Link>.
            </p>

            <h2 className="mt-10">3. Zaplať</h2>
            <p>
                Pro potvrzení objednávky si beru zálohu 50% z platby předem.
                Zbytek doplatíš po dokončení koberečku.
            </p>
            <h3>Platbu přijímám na</h3>
            <ul className="mt-1">
                <li>Bankovní účet</li>
                <li>Revolut</li>
                <li>Paypal</li>
            </ul>

            <h2 className="mt-10">4. Odeslání</h2>
            <p>
                Po provedení platby a vybrání tarifu dopravy ti kobereček
                odešlu. Ten z pravidla bývá do dvou dnů doručen.
            </p>
            <p>
                <strong>Děkuji!</strong>
            </p>

            <h2 id="contact-form" className="mt-16">
                Kontaktní formulář
            </h2>
            <ContactForm />
        </>
    )
}
